<template>
  <v-card class="d-flex flex-column item" height="100%" :to="to" flat tile>
    <div class="position-relative">
      <img
        @error="imgError"
        class="d-block item-img"
        :src="files + img + '?resize=1&w=300'"
        :alt="title"
      />

      <v-sheet
        class="
          d-flex
          align-center
          justify-center
          flex-column
          grey--text
          text-caption text-sm-body-2 text-center
          font-weight-medium
          item-date
        "
        color="primary"
        :height="xsOnly ? '46px' : '56px'"
        :width="xsOnly ? '46px' : '56px'"
      >
        <div class="white--text">
          {{ formatDate(date, { day: "numeric" }) }}
        </div>
        <div class="text-uppercase white--text">
          {{ formatDate(date, { month: "short" }).replaceAll(".", "") }}
        </div>
      </v-sheet>
    </div>

    <div class="d-flex flex-column pa-4 pa-md-6 item-content">
      <div class="grey--text text-body-2 text-sm-body-1 font-weight-medium">
        {{ title }}
      </div>

      <div
        v-if="subtitle"
        class="
          grey--text
          text--lighten-4 text-body-2 text-sm-body-1
          font-weight-regular
          mt-3 mt-md-4
          item-subtitle
        "
      >
        {{ subtitle }}
      </div>

      <div
        class="
          primary--text
          text-body-2 text-sm-body-1
          font-weight-bold
          pt-4 pt-md-6
          mt-auto
        "
      >
        Leia mais
      </div>
    </div>
  </v-card>
</template>

<script>
import DefaultImg from "../../assets/img/default-img.png";
import { formatDate } from "../../utils/formatDate";

export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      required: true,
    },
  },
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    formatDate,
    imgError(e) {
      e.target.src = DefaultImg;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border: 1px solid var(--v-grey-lighten4);
  outline: 1px solid transparent;
  outline-offset: -2px;
  transition: all 0.1s linear;

  &-img {
    aspect-ratio: 340 / 240;
    margin-left: -1px;
    margin-right: -1px;
    margin-top: -1px;
    object-fit: cover;
    position: relative;
    width: 100%;
    width: calc(100% + 2px);
  }

  &-date {
    bottom: 0;
    line-height: 1.4;
    position: absolute;
    right: -1px;
  }

  &-content {
    border-radius: 0 0 8px 8px !important;
    height: 100%;
  }

  &:hover {
    border: 1px solid var(--v-secondary-base);
    outline: 1px solid var(--v-secondary-base);
  }
}
</style>
